<template>
  <div class="card mb-4">
    <div class="card-body">
      <!-- RECURRING COMMENTED OUT -->
      <!--<h2>Storneringen</h2>-->
      <h2>Openstaande betalingen</h2>
      <hr>
      <div class="table-responsive">
        <table class="table table-paymentarrears">
          <thead>
          <tr>
            <th>#</th>
            <th>Naam</th>
            <th>Bedrag</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="user in users" :key="user.id">
            <td>{{ user.id }}</td>
            <td>{{ user.name }}</td>
            <td>€ {{ user.payment_arrear | currency }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
      props: {
          users: {
              type: Array,
              default: () => [],
          }
      }
  }
</script>


// WEBPACK FOOTER //
// resources/assets/components/PaymentArrears.vue